import {sendServerRequest} from './baseService';

export const badgeService = {
    getBadges,
};

async function getBadges() {
    return sendServerRequest('GET', `/api/badges`);
}
